import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'

export const selectMeta = (state: RootState) => state['@meta']

export const selectDetailMenuSite = createSelector(
  (state: RootState) => state['@meta'],
  (meta) => meta.detailMenuSite.data
)

export const selectIsBot = (state: RootState) => state['@meta'].isBot

export const selectFeatureToggles = createSelector(
  (state: RootState) => state['@meta'],
  (meta) => meta.detailMenuSite.data?.features
)

export const selectMenuMode = createSelector(
  (state: RootState) => state['@meta'],
  (meta) => meta.detailMenuSite.data?.mode || 'live'
)

export const selectTrackers = createSelector(
  (state: RootState) => state['@meta'],
  (meta) => meta.trackers.data
)

export const selectScripts = createSelector(
  (state: RootState) => state['@meta'],
  (meta) => meta.scripts.data
)
